<template>
  <span v-if="!edit" class="px-3" v-on:dblclick="edit = true">
    <span
      v-for="product in value"
      :key="product.material_id"
      class="badge badge-outline"
    >
      <div>
        {{ product.serial }}
        <span v-for="cs in product.characteristics" :key="cs">{{ cs }}</span>
      </div>
      <div class="regular-10">{{ product.name }}</div>
    </span>
    <span v-if="value === undefined || value?.length < 1"> - </span>
  </span>
  <v-select
    style="min-width: 420px; width: 100% !important"
    v-else
    :options="row?.values[extraRow]"
    v-model="value"
    label="serial"
    :placeholder="$t(`finance.notSelected`)"
    :dropdown-should-open="() => edit"
    v-on:focusout="focusOut"
    append-to-body
    multiple
    clearable
  >
    <template v-slot:selected-option="option">
      <div>
        <span>{{ option.serial }}</span>
        <span
          class="ms-1 regular-10"
          v-for="cs in option.characteristics"
          :key="cs"
          >{{ cs }}</span
        >
      </div>
    </template>
    <template v-slot:option="option">
      <span>{{ option.serial }}</span>
      <span
        class="ms-1 regular-10"
        v-for="cs in option.characteristics"
        :key="cs"
        >{{ cs }}</span
      >
      <span class="ms-1 regular-10">{{ option.name }}</span>
    </template>
  </v-select>
</template>

<script>
import tenant from "../../../modules/tenant";

export default {
  name: "OperationComponentSelector",
  props: {
    id: Number,
    row: [Object, Array],
    modelValue: Array,
    itemType: String,
    extraRow: [Object, Array, Number, String],
  },
  data() {
    return {
      value: this.modelValue,
      edit: false,
    };
  },
  computed: {
    storageUrl() {
      return tenant.getAppFilesUrl();
    },
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.$emit("update:modelValue", this.value);
        this.$emit("update", this.value);
        this.$emit("change");
      }
      this.edit = false;
    },
    modelValue: {
      deep: true,
      handler() {
        this.value = this.modelValue;
      },
    },
  },
  methods: {
    focusOut() {
      this.edit = false;
    },
  },
  emits: ["update:modelValue", "update", "change"],
};
</script>
